import { CurationDetailPage } from './CurationDetail.page';

export const curationDetailRouter = {
  '/@/curations/:curation_id': CurationDetailPage,
};
